<template>

<div>
<div class="boolean_selector">
<div class="boolean_selector_option animate_class" :class="{'boolean_selector_option_false_selected':inputdata===0 }" @click="submitInputData(0)"><i class="pi pi-times" ></i></div>
<div class="boolean_selector_option animate_class" :class="{'boolean_selector_option_true_selected':inputdata===1 }" @click="submitInputData(1)"><i class="pi pi-check" ></i></div>

</div>

</div>

</template>

<script>
export default {

  name: 'BooleanType',
  props:["data"],

  data () {
    return {
    	inputdata:null,
    	intervalobj:null,
    }
  },
  mounted()
  {
  	 if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_option
      }
      else
      {
        this.inputdata = null
      }
  	
  },
  computed:{
    propdata()
    {

      if(this.data.submissions.length>0)
      {
        let propdata = this.data.submissions[0].submission_option

        return propdata
      }
    }
  },
  watch:{
     propdata(newval)
    {
      this.inputdata = newval
    },
    data()
    {
      if(this.data.submissions.length>0)
      {
        this.inputdata = this.data.submissions[0].submission_option
      }
      else
      {
        this.inputdata = null
      }
    },
  },
  methods: {
  	fieldChanged()
  	{
  		clearInterval(this.intervalobj);
  		this.intervalobj = setInterval(()=>{
  			this.submitInputData()
  		},1000)
  	},
  	submitInputData(input)
  	{
  		//clearInterval(this.intervalobj);
      if(!this.data.read_only_state)
      {
        this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
        this.inputdata = input
        let formdata = new FormData()
        formdata.append("option",input)
        formdata.append("type","boolean")
        formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)

        //return false
        this.submitInputFieldSubmission(formdata,this.data.id)
      }
      
  	},
  }
};
</script>

<style lang="css" scoped>
</style>